import React from "react";

import "./MoreInfos.css";

export default function MoreInfos() {
  return (
    <div className="MoreInfos">
      <p>
        <a href="https://www.accuweather.com/">More infos</a>
      </p>
    </div>
  );
}
